import { useContext, useEffect, useState } from "react"
import ApiContext from "src/provider/API/call-service"
import { 
    SidePopupContainer, FlexColumn, Button, 
    Form, FormGroup, FlexRow, AppSpan, CustomContainer, AppText, AppLabel, FormGroupWithIcon 
} from "src/style"
import { RiCloseFill } from "react-icons/ri"
import { RadioSelection } from "src/component"
import { FiChevronDown } from "react-icons/fi"
import { BsDot } from "react-icons/bs";
import { useNotifier } from "react-pop-notifier"
import { Fee } from "src/model"

export const Assign_ModifyFee: React.FC<any> = ({getServices, serviceData, productData, isBillingSetup, isEdit, close}) => {
    const {notifier} = useNotifier()
    const {API} = useContext(ApiContext)
    const [input, setInput] = useState<any>({
        customerFeeType: 'Flat', providerFeeType: 'Flat', 
        customerFees: {}, providerFees: {},
        frequency: 'Realtime'
    })
    const [currentCustomerFee, setCurrentCustomerFee] = useState('')
    const [currentProviderFee, setCurrentProviderFee] = useState('')
    const [fees, setFees] = useState<Array<Fee>|null>(null)

    useEffect(() => {
        if (serviceData && isEdit) {
            let {feeType, providerFeeType, feeList, providerFees, frequency} = serviceData
            if (!feeList) feeList = {existingFee: ''} // to be removed
            if (!providerFees) providerFees = {existingFee: ''} // to be removed
            
            setInput({
                ...input, 
                customerFeeType: feeType, customerFees: feeList, providerFeeType, 
                providerFees, frequency
            })
        }
    }, [serviceData])

    useEffect(() => {
        handleFetchFees()
    }, [])

    async function handleFetchFees() {
        const response = await API.getFeesWithoutPagination()
        if (response) setFees(response)
    }

    function handleFees (e: React.ChangeEvent<HTMLSelectElement>, type: string) {
        if (type === 'customer') {
            const customerFees = {...input.customerFees, [e.target.name]: e.target.value}
            setInput({...input, customerFees})
        }
        else {
            const providerFees = {...input.providerFees, [e.target.name]: e.target.value}
            setInput({...input, providerFees})
        }
    }

    function handleFeeType (type: string) {
        const fees = type === 'Flat' ? {existingFee: ''} : {}
        setInput({...input, customerFees: fees, customerFeeType: type})
    }

    function handleAddMore(type: string) {
        if (type === 'customer') {
            if (!currentCustomerFee) return notifier.show('Kindly enter the fee to be added')

            const propertyCount = Object.keys(input.customerFees)?.length
            const customerFees = {...input.customerFees, [`existingFee${propertyCount}`]: currentCustomerFee}
            setInput({...input, customerFees})
            setCurrentCustomerFee('')
        }
        else {
            if (!currentProviderFee) return notifier.show('Kindly enter the fee to be added')

            const propertyCount = Object.keys(input.providerFees)?.length
            const providerFees = {...input.providerFees, [`existingFee${propertyCount}`]: currentProviderFee}
            setInput({...input, providerFees})
        }
    }

    async function handleSubmit (e: React.FormEvent<HTMLButtonElement | HTMLFormElement>) {
        e.preventDefault()
        const feeIds = Object.values(input.customerFees)
        if (!feeIds.length) return notifier.show('Kindly enter the fee to be added')

        const payload = {
            id: serviceData?.id,
            feeIds, 
            frequency: input.frequency,
            feeType: input.customerFeeType,
            serviceCode: serviceData?.code,
            productId: productData?.id
        }

        const response = isEdit ? await API.UpdateServiceFee(payload)
            : await API.AddFeeToService(payload)
        
        if (response) {
            if (getServices) getServices()
            close()
        }
    }

    return (
        <>
            <SidePopupContainer zIndex="8" onClick={close} />
            <FlexColumn
                className="center-popup-container"
                justifyContent="flex-start"
                alignItems="flex-start" 
            >
                <FlexRow justifyContent='space-between' gap='2'>
                    <AppSpan color='#101828' textSize='1.8' fontWeight="600">Configure Service Fee</AppSpan>
                    <Button 
                        titleSize="2" fontWeight="500"
                        width='3.4' shadow='none'
                        height='3.4'
                        radius='0.4'
                        bgColor='#ffffff'
                        hoverBgColor='#FEF3F2'
                        borderColor='none'
                        color='#000000'
                        hoverColor='#B42318'
                        onClick={close}
                    >
                        <RiCloseFill style={{fontSize: '2.3rem'}} />
                    </Button> 
                </FlexRow>
                <Form onSubmit={handleSubmit} topMargin='2'>
                    <CustomContainer>
                    { !isBillingSetup &&
                        <CustomContainer bottomMargin='1'>
                            <AppLabel color='#344054' fontWeight="500" bottomMargin='0.8'>Fee type frequency</AppLabel>
                            <RadioSelection 
                                option1='Realtime' 
                                option2='Monthly'
                                value={input.frequency}
                                output={(val: any) => setInput({...input, frequency: val})} 
                            />
                        </CustomContainer>
                    }
                    <AppText 
                        color='#344054' fontWeight="600"
                        bottomPadding="1"
                        style={{borderBottom: '1px solid #EAECF0'}}
                    >
                        {!isBillingSetup ? 'Customer fee configuration' : 'Flat monthly fee'}
                    </AppText>
                    <CustomContainer bottomMargin='0.5' topMargin="1.5">
                        <AppLabel color='#344054' fontWeight="500" bottomMargin='0.8'>Select customer fee type</AppLabel>
                        <RadioSelection 
                            option1='Flat' 
                            option2='Group'
                            value={input.customerFeeType}
                            output={(val: any) => handleFeeType(val)} 
                        />
                    </CustomContainer>
                        {
                            Object.keys(input.customerFees)?.map((item, index) => {
                                return (
                                    <FormGroupWithIcon key={index}>
                                        <label>Select existing Fee</label>
                                        <div className="input-with-icon">
                                            <select 
                                                name={`${item}`}
                                                value={input.customerFees[item]}
                                                onChange={(e) => handleFees(e, 'customer')}
                                                autoComplete='off'
                                                style={{color: input.customerFees[item] ? '#101828' : '#667085'}}
                                                disabled={input.customerFeeType != 'Flat'}
                                            >
                                                <option value="">Select fee</option>
                                                {
                                                    fees?.map((fee: Fee, index) => {
                                                        return (
                                                            <option value={fee.id} key={index}>{fee.name}</option>
                                                        )
                                                    })
                                                }
                                            </select>
                                            <FiChevronDown className="input-with-icon-tag" />
                                        </div>
                                    </FormGroupWithIcon>
                                )
                            })
                        }
                        { input.customerFeeType === 'Group' &&
                            <FlexRow justifyContent="space-between" gap="1.5" bottomMargin="1.5">
                            <FormGroupWithIcon width="70" bottomMargin="0">
                                <label>Select existing Fee</label>
                                <div className="input-with-icon">
                                    <select 
                                        name='currentCustomerFee'
                                        value={currentCustomerFee}
                                        onChange={(e) => setCurrentCustomerFee(e.target.value)}
                                        style={{color: currentCustomerFee ? '#101828' : '#667085'}}
                                        autoComplete='off'
                                    >
                                        <option value="">Select fee</option>
                                        {
                                            fees?.map((fee: Fee, index) => {
                                                return (
                                                    <option 
                                                        value={fee.id} 
                                                        key={index}
                                                        disabled={Object.values(input.customerFees)?.includes(fee.id)}
                                                    >
                                                        {fee.name}
                                                    </option>
                                                )
                                            })
                                        }
                                    </select>
                                    <FiChevronDown className="input-with-icon-tag" />
                                </div>
                            </FormGroupWithIcon>
                            <Button
                                width='30' sizeUnit="%" topMargin="3"
                                titleSize='1.4' fontWeight="500"
                                height='4.4' radius='0.8'
                                bgColor="#E7F6F5" color='#0A756F'
                                hoverBorderColor="#0A756F"
                                type="button"
                                onClick={() => handleAddMore('customer')}
                            >
                                <BsDot fill="#0A756F" fontSize='2rem' /> Add More
                            </Button>
                        </FlexRow>
                        }
                    </CustomContainer>  

                    {/* <CustomContainer>
                        <AppText 
                            color='#344054' fontWeight="600"
                            bottomPadding="1"
                            style={{borderBottom: '1px solid #EAECF0'}}
                        >
                            Select Service Provider Fee type
                        </AppText>
                        <CustomContainer bottomMargin='0.5' topMargin="1.5">
                            <AppLabel color='#344054' fontWeight="500" bottomMargin='0.8'>Select provider fee configuration</AppLabel>
                            <RadioSelection 
                                option1='Flat fee' 
                                option2='Group configuration'
                                value={input.providerFeeType}
                                output={(val: any) => setInput({...input, providerFeeType: val})} 
                            />
                        </CustomContainer>
                        {
                            Object.keys(input.providerFees)?.map((item, index) => {
                                return (
                                    <FormGroupWithIcon key={index}>
                                        <label>Select existing Fee</label>
                                        <div className="input-with-icon">
                                            <select 
                                                name={`${item}`}
                                                value={input.providerFees[item]}
                                                onChange={(e) => handleFees(e, 'provider')}
                                                autoComplete='off'
                                                required
                                            >
                                                <option value="">Select fee</option>
                                                <option value="platform">Platform fee</option>
                                                <option value="license">License fee</option>
                                            </select>
                                            <FiChevronDown className="input-with-icon-tag" />
                                        </div>
                                    </FormGroupWithIcon>
                                )
                            })
                        }
                        { input.providerFeeType === 'Group configuration' &&
                            <FlexRow justifyContent="space-between" gap="1.5" bottomMargin="1.5">
                            <FormGroupWithIcon width="70" bottomMargin="0">
                                <label>Select existing Fee</label>
                                <div className="input-with-icon">
                                    <select 
                                        name='currentProviderFee'
                                        value={currentProviderFee}
                                        onChange={(e) => setCurrentProviderFee(e.target.value)}
                                        autoComplete='off'
                                    >
                                        <option value="">Select fee</option>
                                        <option value="platform">Platform fee</option>
                                        <option value="license">License fee</option>
                                    </select>
                                    <FiChevronDown className="input-with-icon-tag" />
                                </div>
                            </FormGroupWithIcon>
                            <Button
                                width='30' sizeUnit="%" topMargin="3"
                                titleSize='1.4' fontWeight="500"
                                height='4.4' radius='0.8'
                                bgColor="#E7F6F5" color='#0A756F'
                                hoverBorderColor="#0A756F"
                                type="button"
                                onClick={() => handleAddMore('provider')}
                            >
                                <BsDot fill="#0A756F" fontSize='2rem' /> Add More
                            </Button>
                        </FlexRow>
                        }
                    </CustomContainer>   */}
                    
                    <FlexRow justifyContent='flex-end' topMargin="1.5">
                        <Button
                            width='11'
                            titleSize='1.4' fontWeight="500"
                            height='4' radius='0.8'
                            hoverColor='#0D968F'
                            hoverBgColor='#fff' borderColor='#0D968F'
                        >
                            {isEdit ? 'Save' : 'Submit'}
                        </Button>
                    </FlexRow>
                </Form>
            </FlexColumn>
        </>
    )
}